
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 5h13c1.66 0 3 1.34 3 3v9c0 1.66-1.34 3-3 3H5c-1.66 0-3-1.34-3-3V8c0-1.66 1.34-3 3-3m0 1c-.5 0-.94.17-1.28.47l7.78 5.03 7.78-5.03C18.94 6.17 18.5 6 18 6H5m6.5 6.71L3.13 7.28C3.05 7.5 3 7.75 3 8v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V8c0-.25-.05-.5-.13-.72l-8.37 5.43z"}})])
          )
        }
      }
    